import React from "react";

interface IResultGaugeChartProps {
    score: number;
}

const ResultGaugeChart = (props: IResultGaugeChartProps) => {
    const { score } = props;

    const normalizedScore = Math.min(Math.max(score, 0), 100); // Ensure score is between 0-100
    const gaugeFillColor = normalizedScore > 70
        ? 'good'
        : normalizedScore > 40
            ? 'average'
            : 'poor';

    return (
        <div className="immersion__results__gauge_chart">
            <div className="immersion__results__gauge_chart__gauge">
                <div
                    className={`immersion__results__gauge_chart__gauge__fill immersion__results__gauge_chart__gauge__fill__${gaugeFillColor}`}
                    style={{
                        width: `${normalizedScore}%`,
                    }}
                ></div>
                <div className="immersion__results__gauge_chart__gauge__cover"></div>
            </div>
            <div className="immersion__results__gauge_chart__text">
                <h1 className="immersion__results__gauge_chart__text__score">{score}</h1 >
                <label className="immersion__results__gauge_chart__text__label">Overall Score</label>
            </div>
        </div>
    );
};

export default ResultGaugeChart;